import dashboard from './dashboard';
import lancamentos from './lancamentos';
import carteiras from './carteiras';
import analise from './analise';
import meses from './meses';
import parametrizacoes from './parametrizacoes';
import roadmap from './roadmap';
import admin from './admin';

export function getMenuItems({ isPlatformAdmin, suggestionsPendingCount = 0 } = {}) {
  const items = [dashboard, lancamentos, carteiras, analise, meses, roadmap];

  if (isPlatformAdmin) {
    // Badge com o número de sugestões aguardando avaliação.
    const adminGroup = {
      ...admin,
      children: admin.children.map((child) =>
        child.id === 'admin-sugestoes' && suggestionsPendingCount > 0
          ? { ...child, chip: { label: String(suggestionsPendingCount), color: 'primary', size: 'small', variant: 'filled' } }
          : child
      )
    };

    items.push(parametrizacoes, adminGroup);
  }

  return { items };
}

// Usado pelo Breadcrumbs só para resolver títulos de rota — não precisa de filtragem por permissão.
const menuItems = { items: [dashboard, lancamentos, carteiras, analise, meses, roadmap, parametrizacoes, admin] };

export default menuItems;
